
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.222 2h-3.083a.75.75 0 00-.75.75v18.5c0 .413.336.75.75.75h3.083a.75.75 0 00.75-.75V2.75a.75.75 0 00-.75-.75zM6.862 6.112H3.777a.75.75 0 00-.75.75V21.25c0 .414.336.75.75.75H6.86a.75.75 0 00.75-.75V6.862a.75.75 0 00-.75-.75zm6.68 5.138h-3.083a.75.75 0 00-.75.75v9.25c0 .413.335.75.75.75h3.083a.75.75 0 00.75-.75V12a.75.75 0 00-.75-.75z"}})])
          )
        }
      }
    